import React from "react"
import { Global, css } from "@emotion/core"

import interRegularWoff2 from "../../assets/fonts/inter-optimized/inter-regular-webfont.woff2"
import interSemiBoldWoff2 from "../../assets/fonts/inter-optimized/inter-semibold-webfont.woff2"
import interBoldWoff2 from "../../assets/fonts/inter-optimized/inter-bold-webfont.woff2"

function GlobalStyles() {
  return (
    <Global
      styles={theme => css`
         @font-face {
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url("${interRegularWoff2}") format("woff2");
        }

        @font-face {
          font-family: "Inter";
          font-style: italic;
          font-weight: 400;
          font-display: swap;
          src: url("${interSemiBoldWoff2}") format("woff2");
        }

        @font-face {
          font-family: "Inter";
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url("${interBoldWoff2}") format("woff2");
        }

        html {
          overflow-y: unset;
        }

        body {
          overflow: visible;
          &.dashboardGreyBg {
            background: ${theme.colors.secondaryBackground};
          }
        }

        /* CSS reset */

        /* Reset for <fieldset> based on https://thatemil.com/blog/2015/01/03/reset-your-fieldset/ */
        fieldset {
          border: 0;
          margin: 0;
          padding: 0.01em 0 0 0;
          min-width: 0;
        }
      `}
    />
  )
}

export default GlobalStyles
